import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@iota/iota-ui-components';

@Injectable({
    providedIn: 'root'
})
export class PaginatorIntlService extends MatPaginatorIntl {
    itemsPerPageLabel = $localize`Items per page`;
    nextPageLabel = $localize`Next page`;
    previousPageLabel = $localize`Previous page`;
    firstPageLabel = $localize`First page`;
    lastPageLabel = $localize`Last page`;

    // Mirrors Material's default range label so the "of" is translatable too
    getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return $localize`0 of ${length}:total:`;
        }

        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

        return $localize`${startIndex + 1}:start: – ${endIndex}:end: of ${length}:total:`;
    };
}
